import MenuMaker from '../components/Menu/MenuMaker';

const YourMenu = () => {
  return <MenuMaker />;
};

export default YourMenu;
